//Vendors
import { useCallback, useEffect, useRef, useState } from 'react';
export const useExecuteAfter = ({ limitTime, onLimitTime, }) => {
    const [isTimerActive, setIsTimerActive] = useState(false);
    const time = useRef(limitTime ?? 0);
    const startTimer = useCallback(() => {
        time.current = limitTime ?? 0;
        limitTime && setIsTimerActive(true);
    }, [limitTime]);
    const stopTimer = useCallback(() => {
        setIsTimerActive(false);
    }, []);
    useEffect(() => {
        if (!limitTime || !isTimerActive) {
            return;
        }
        const interval = setInterval(async () => {
            if (time.current > 0) {
                time.current = time.current - 1;
                return;
            }
            clearInterval(interval);
            setIsTimerActive(false);
            await onLimitTime();
        }, 1000);
        return () => clearInterval(interval);
    }, [limitTime, isTimerActive]);
    return {
        startTimer,
        stopTimer,
    };
};
//# sourceMappingURL=useExecuteAfter.js.map